import GoodsModal from './GoodsModal'
import GoodsPoinModal from './GoodsPoinModal'
import GoodsModalStore from './GoodsModalStore'
import AreasModal from './AreasModal'
// import FilesModal from './FilesModal'
import LinkModal from './LinkModal'
import CouponModal from './CouponModal'
import LiveModal from './LiveModal/LiveModal.vue'
import NewCouponModal from './CouponModal/NewCouponModal.vue'
import CouponpackModal from './CouponpackModal/index.vue'
// import UserModal from './UserModal'

export {
    //  AreasModal, FilesModal,  UserModal
  GoodsPoinModal,LinkModal, GoodsModal, CouponModal,AreasModal,GoodsModalStore,NewCouponModal,LiveModal,CouponpackModal
}
